import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { auth as actions } from "actions";
import GoogleLogin from "react-google-login";
import GoogleButton from "components/elements/Google_Button";
import { returnGoogleClientId } from "functions";

class SocialLogins extends Component {
  responseGoogle = async (res) => {
    try {
      if (res.error) {
        console.error("Google login error:", res.error);
        return;
      }

      if (!res.tokenId) {
        console.error("Google login failed — missing tokenId:", res);
        return;
      }

      await this.props.googleLogIn(res.tokenId, this.props.history);
    } catch (err) {
      console.error("Error during googleLogIn:", err);
    }
  };

  render() {
    const { login, register, messages, locale } = this.props;
    const clientId = returnGoogleClientId();

    if (!clientId) {
      console.error("Google Client ID missing — check returnGoogleClientId()");
      return null;
    }

    const buttonText =
      (login && messages?.google?.login?.[locale]) ||
      (register && messages?.google?.register?.[locale]) ||
      "Continue with Google";

   return (
  <div style={{ paddingBottom: 20, paddingTop: 10 }}>
    <div className="buttons">
      <GoogleLogin
        clientId={clientId}
        onSuccess={this.responseGoogle}
        onFailure={this.responseGoogle}
        cookiePolicy="single_host_origin"
        uxMode="popup" // ⬅️ TÄMÄ LISÄTTY
        render={(renderProps) => (
          <GoogleButton {...this.props} onClick={renderProps.onClick}>
            {buttonText}
          </GoogleButton>
        )}
      />
    </div>
  </div>
);

  }
}

const mapStateToProps = (state) => ({
  locale: state.intl.locale,
  messages: {
    google: state.intl.messages?.components?.buttons?.google || {},
  },
});

export default connect(mapStateToProps, actions)(withRouter(SocialLogins));
